/**
 * @typedef {object} SizeMapping
 * @param {number[][]} sizes
 * @param {number[]} viewport
 */

/**
 * @typedef {object} AdPositionData
 * @param {number[]} defaultSize
 * @param {SizeMapping[]} sizeMapping
 * @param {number} wordCount
 * @param {string} id
 * @param {string[]} pos
 */

/**
 * Builds an ad position.
 * @param {string} id
 * @param {string[]} pos
 * @param {number} wordCount
 * @param {Partial<AdPositionData>} [rest]
 * @returns {AdPositionData}
 */
const buildPosition = ({
  id,
  pos,
  wordCount,
  ...rest
}) => {
  const baseAd = {
    defaultSize: [728, 90],
    sizeMapping: [
      {
        viewport: [970, 0],
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
        ],
      },
      {
        viewport: [768, 0],
        sizes: [
          [728, 90],
          [300, 250],
        ],
      },
      {
        viewport: [0, 0],
        sizes: [
          [320, 50],
          [300, 250],
        ],
      },
    ],
  };

  return {
    ...baseAd,
    id,
    pos,
    wordCount,
    ...rest,
  };
};

/**
 * @param {string} networkId
 * @param {string} unit
 * @param {Object.<string, AdPositionData>} positions
 */
export default {
  networkId: '61381659',
  unit: 'bostonglobe.com/special-projects/globe150',
  positions: {
    ad_inarticle1: buildPosition({
      id: 'ad_inarticle1',
      pos: ['ad_inarticle1', 'atf'],
    }),
    ad_inarticle2: buildPosition({
      id: 'ad_inarticle2',
      pos: ['ad_inarticle2', 'atf'],
    }),
    ad_inarticle3: buildPosition({
      id: 'ad_inarticle3',
      pos: ['ad_inarticle3', 'atf'],
    }),
    ad_inarticle4: buildPosition({
      id: 'ad_inarticle4',
      pos: ['ad_inarticle4', 'atf'],
    }),
    ad_inarticle5: buildPosition({
      id: 'ad_inarticle5',
      pos: ['ad_inarticle5', 'atf'],
    }),
  },
};
